/// <reference types="vite/client" />

export const API_BASE_URL: string = import.meta.env['VITE_API_BASE_URL'] ?? 'https://api.athenty.com/v2/api'
export const AUTH_BASE_URL: string = import.meta.env['VITE_AUTH_BASE_URL'] ?? 'https://api.athenty.com/v2/auth'
export const APP_BASE_URL: string = import.meta.env['VITE_APP_BASE_URL'] ?? 'https://app.athenty.com'

export const STORAGE_KEY = 'athenty-planner-outlook'

export const BRAND = {
  blue: '#2F6CAA',
  teal: '#52B6BD',
  gradient: 'linear-gradient(135deg, #2F6CAA 0%, #52B6BD 100%)',
} as const
